import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { renderComponentField } from '@/shared/components/form/FormField';
import styled from 'styled-components';
import { colorBackground, colorBlue, colorFieldsBorder, colorIcon, colorText, colorHover } from '@/utils/palette';
import { borderRight, marginLeft, marginRight } from '@/utils/directions';

export const SelectField = React.forwardRef(
  ({ onChange, value, name, placeholder = '', options = [], ...other }, ref) => {
    const handleChange = (selectedOption) => {
      onChange(selectedOption);
    };

    return (
      <StyledSelect
        name={name}
        value={value}
        onChange={handleChange}
        options={options}
        clearable={false}
        className='react-select'
        placeholder={placeholder}
        classNamePrefix='react-select'
        maxMenuHeight={400}
        menuPlacement='auto'
        ref={ref}
        {...other}
      />
    );
  },
);

SelectField.displayName = 'SelectField';

SelectField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
};

// SelectField.defaultProps = {
//   placeholder: '',
//   options: [],
// }

export default renderComponentField(SelectField);

// region STYLES

const StyledSelect = styled(Select)`
  z-index: 101;
  position: absolute;
  width: auto;
  height: 100%;
  font-size: 12px;
  ${marginLeft}: 0;
  color: ${colorText};

  .css-1fdsijx-ValueContainer {
    padding: 0px;
    color: ${colorText};
  }

  /* Add custom scrollbar styles here */
  .react-select__menu-list {
    overflow-y: auto;
    scrollbar-width: thin; /* For Firefox */
    scrollbar-color: #888 #f0f0f0; /* For Firefox */

    &::-webkit-scrollbar {
      width: 15px; /* Width of the scrollbar */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #888; /* Color of the scrollbar thumb */
      border-radius: 5px; /* Radius of the scrollbar thumb */
    }

    &::-webkit-scrollbar-track {
      width: 15px; /* Width of the scrollbar track */
      background-color: #f0f0f0; /* Color of the scrollbar track */
    }
  }


 .css-1fdsijx-ValueContainer{
  padding: 0px;
  color: ${colorText};

}
  .react-select__control {
    height: 100%;
    border-style: none;
    background: ${colorBackground};
    color: ${colorText};
     

    &.react-select__control--is-focused {
      box-shadow: none;
      border-style: none;
      background-color: ${colorHover};
      color: ${colorText};
    
    }
  }

  .react-select__input-container {
    color: ${colorText};
  }

  .react-select__option:hover {
    background-color: ${colorHover};
    color: ${colorText};
  }

  .react-select__option--is-focused {
    background-color: ${colorHover};
  }

  .react-select__option--is-selected {
    background-color: ${colorHover};
    color: ${colorText};
  }

  .react-select__input {
    height: 30px;
    width: auto;
    color: ${colorText};
  }


  .react-select__indicator-separator {
    display: none;
    
  }

  .react-select__dropdown-indicator, .react-select__clear-indicator {
    cursor: pointer;
    color: ${colorIcon};

    svg {
      height: 16px;
      width: 16px;
    }
  }

  .react-select__multi-value {
    background-color: transparent;

    .react-select__multi-value__label {
      // padding: 3px 6px;
      ${borderRight}: 1px solid ${colorBlue};
      color: ${colorText};
    }
  }

  .react-select__multi-value__remove {
    opacity: 0.8;
    transition: 0.3s;
    cursor: pointer;
    color: ${colorText};
  }

  .react-select__multi-value__label, .react-select__multi-value__remove {
    background: ${colorBackground};
    color: ${colorText};
  }

  .react-select__single-value {
    color: ${colorText};
    ${marginRight}: 0;

  }

  .react-select__menu {
    box-shadow: none !important;
    margin-top: 6px;
    margin-bottom: 6px;
    min-width:210px;

    
  
  

  .react-select__menu-list {
    top: calc(100% + 1px);
    border-radius: 0;
    box-shadow: none;
    cursor: pointer;
    font-size: 12px;
    overflow-y: scroll;
    color: ${colorText};
    background: ${colorBackground};
    border: 1px solid ${colorFieldsBorder};

    &::-webkit-scrollbar {
      width: 2px; 
      opacity: 0; 
      transition: opacity 0.5s ease; 
  
    &:hover::-webkit-scrollbar {
      opacity: 1; 
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: #888; 
      border-radius: 1px; 
    }
  
    &::-webkit-scrollbar-track {
      background-color: ${colorBackground}

  }

  @keyframes open {
    0% {
      max-height: 0
    }
    100% {
    }
  }

  .react-select__placeholder {
    font-size: 12px;
    margin-top: -2px;
    color: ${colorText};

  }
  
  .react-select__value-container {
    padding-top: 0;2
    padding-bottom: 0;
    
    & > div {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

`;
